<template>
  <div class="m_base">
    <ul>
      <li v-for="element in elements" :key="element.id" class="container">
        <div class="left">
          <p :class="{'m_unpublic': !element.isPublic}"><span class="type">{{ element.type +  '_' + element.order }}:</span>{{element.title.substr(0, 40)}}</p>
        </div>
        <router-link :to="{name: 'ManagerEditElement', params:{id: element.id}}" class="edit _eg">Edit</router-link>
      </li>
    </ul>
    <router-link :to="{name: 'ManagerCreateElement'}" class="m_go _eg">Create New Element</router-link>
  </div>
</template>

<script>

import "@/css/manager.css"
import {db} from '@/firebase/index.js'

export default {
  components:{

  },
  props:{
    is_sign: Boolean
  },
  data(){
    return{
      pageName: "element",
      isError: false,

      elements:[],

    }
  },
  beforeCreate(){

  },
  created(){
    this.$store.commit('managerPageName', this.pageName)
    if(!this.is_sign){
      this.$router.push({name: 'Manager'})
    }
    db.collection('element').orderBy('createdAt', 'desc').get()
    .then((querySnapShot)=>{
      querySnapShot.forEach(doc => {
        this.elements.push(doc.data())   
      });
    })

  },
  mounted(){

  },
  methods:{

    
  },
  watch: {

  },
  computed:{

  },

}
</script>


<style scoped>
ul {
  margin-bottom: 50px;
}
.container{
  display: flex;
  justify-content: space-between;
  height: 20px;
  margin-bottom: 30px;
}
.container:hover{
  box-sizing: border-box;
  border-bottom: 1px solid var(--black);
}
.left{
  display: flex;
}
.left p{
  line-height: 20px;
  margin-right: 10px;
}

.edit{
  background-color: var(--gray-sub);
  color: var(--white);
  display: block;
  width: 50px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  font-size: 1.2rem;
}

.type{
  width: 100px;
  display: inline-block;

}
@media screen and (min-width:600px){

}

</style>